import { render } from "./StopDataflow.vue?vue&type=template&id=1fc3c03b&scoped=true&ts=true"
import script from "./StopDataflow.vue?vue&type=script&lang=ts"
export * from "./StopDataflow.vue?vue&type=script&lang=ts"

import "./StopDataflow.vue?vue&type=style&index=0&id=1fc3c03b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc3c03b"]])

export default __exports__